import React from 'react';
import styled from 'styled-components';
import TooltipModal from '@ui/TooltipModal';
import { Body5, Container } from '@ui';
import { CloseButton } from '@ui/buttons/CloseButton';

const DiffModeFlagWrapper = styled.div`
  cursor: pointer;

  position: absolute;
  top: ${({ Offset }) => Offset || 0}px;
  left: ${({ Offset }) => 3}px;

  width: 13px;
  height: 14px;

  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  z-index: 10;

  background: ${({ theme }) => theme.themeColors.primaryCtaButton};

  div {
    padding-top: 1px;
    padding-left: 1px;
    margin-top: 0px;
    margin-left: 0px;
  }

  svg {
    height: 11px;
    width: 11px;

    path {
      fill: ${({ theme }) => theme.themeColors.buttonText};
    }
  }
`;
const DiffModeTooltipWrapper = styled.td`
  position: relative;
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  z-index: 100000;
  border-radius: 5px;
  padding: 20px;
`;
const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;

  * {
    z-index: 6;
  }

  svg {
    height: 10px;
    width: 10px;
  }

  path {
    fill: ${({ theme }) => theme.themeColors.text} !important;
  }
`;

const DiffModeTooltip = ({ onDismiss }) => {
  return (
    <DiffModeTooltipWrapper>
      <CloseButtonWrapper>
        <CloseButton onClick={onDismiss} />
      </CloseButtonWrapper>
      <Container right={20}>
        <Body5>This question has "Include adjacent document, e.g. for comparisons and diffs" enabled</Body5>
      </Container>
    </DiffModeTooltipWrapper>
  );
};

export const DiffModeFlag = ({ offset }) => {
  const [show, setShow] = React.useState(false);

  const onDismiss = () => {
    setShow(false);
  };

  return (
    <>
      {show && <TooltipModal onDismiss={onDismiss} customRender={<DiffModeTooltip onDismiss={onDismiss} />} />}
      <DiffModeFlagWrapper onClick={() => setShow(true)} Offset={offset}>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M8,10V13H14V18H8V21L2,15.5L8,10M22,8.5L16,3V6H10V11H16V14L22,8.5Z" />
          </svg>
        </div>
      </DiffModeFlagWrapper>
    </>
  );
};
